import React, { useEffect, useState, useRef } from "react";
import { getBgColor, mergeFilters } from "../../utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ColorRing } from "react-loader-spinner";

import { setSelectedCaratRange, setSelectedCell, setSelectedClarities, setSelectedCoClCell, setSelectedColors } from "../../redux/slices/miShapeCaratSlice";

import {useGetHigherLevelAnalysisMovementHistoryQuery, useGetHigherLevelMarketIntelligenceGridataShapeCaratQuery } from "../../redux/slices/apiSlice";
import MIHigherLevelIndividualMoment from "./MIHigherLevelIndividualMoment";
import MIFourDropGraph from "./MIFourDropGraph";
import MIDetailedColorClarity from "./MIDetailedColorClarity";
import { skipToken } from "@reduxjs/toolkit/query";

const MIColorClarityGrid = ({
  isCsr, accountDetails,queryParams,selectedShape,selectedCaratRange, shape,isResetting, selectedMetric,caratRange, highlightedGroup}) => {
  
  const ready = queryParams.shape && queryParams.carat_range;
  // State for data
  const [isDataLoading, setIsDataLoading] = useState(true);
  const { data: newData, isLoading: isColorClarityLoading } = useGetHigherLevelMarketIntelligenceGridataShapeCaratQuery(ready ? queryParams : skipToken, {
    refetchOnMountOrArgChange: true
  });

  const [colorKeys, setColorKeys] = useState([]);
  const [clarityDatas, setClarityDatas] = useState([]);
  const [allClarityRanges, setAllClarityRanges] = useState([]);
  const [colorGroupsApi, setColorGroupsApi] = useState({});
  const [clarityGroupsApi, setClarityGroupsApi] = useState({});
  const drilldownRef = useRef(null);
  

  // const [selectionMode, setSelectionMode] = useState('individual');
  const dispatch = useDispatch();  
  const {
    
    selectedCell,
    selectedClarity,
    selectedColor,
    selectedCoClCell,
    selectedNeedsMetric,
    selectedLocation
    
  } = useSelector((state) => state.marketIntelligenceShapeCarat); 
  
    const [queryNParams, setQueryNParams] = useState({
        shape: shape,
        carat_range: caratRange,
    });

   useEffect(() => {
      setQueryNParams((prevParams) => ({
        ...prevParams,
        shape: shape,
        carat_range: caratRange,
      }));
    }, [shape, caratRange]);  

  const getCellStyle = (bgColor, color, clarity, cellData, outline) => {
    const isSelected = selectedCoClCell?.color === color && selectedCoClCell?.clarity === clarity;
    const highlighted = isHighlighted(color, clarity);
    // const boxShadow = highlighted ? getBoxShadow(colors.indexOf(color), clarities.indexOf(clarity)) : "none";
    
      return {
        backgroundColor: bgColor,
        // boxShadow: highlighted ? boxShadow : "none",
        fontWeight: highlighted ? "bold" : "normal",
        border: isSelected ? "2px solid #000" : "1px solid #ccc",
        outline: outline,
        // transition: "all 0.2s ease",
      };
  };
  
  //  const { data:graphData, isLoading, isFetching } = useGetHigherLevelAnalysisMovementHistoryQuery(
  //   queryNParams,
  //     {
        
  //       refetchOnMountOrArgChange: true
  //     }
  //   );  
  
    
  // write a function to return number with one decimal place for any given number or integer
  function roundToOneDecimal(value) {
    return (Math.round(value * 10) / 10).toFixed(1);
  }
  
  function roundIfFloat(value) {
    // Check if the value is a number and if it has a decimal part
    if (typeof value === 'number' && value % 1 !== 0) {
      // Round the number to 2 decimal places
      return Math.round(value * 100) / 100;
    }
    // Return the value as it is if it's not a float
    return value;
  }
  
  // Define matching logic for highlighted cells
  const isHighlighted = (color, clarity) => {
    if (!highlightedGroup) return false;

    const colorGroup = colorGroupsApi[highlightedGroup[0]];
    const clarityGroup = clarityGroupsApi[highlightedGroup[1]];

    return (
      (colorGroup && colorGroup.includes(color)) &&
      (clarityGroup && clarityGroup.includes(clarity))
    );
  };

  

  const handleCellClick = (color, clarity, cellData) => {
    
    handleSelectionChange({ colors: [color], clarities: [clarity] });
    // setSelectedCell({ color, clarity, inventory, sales });
    
    dispatch(setSelectedClarities(clarity))
    dispatch(setSelectedColors(color))
    dispatch(setSelectedCoClCell({ color, clarity }));
              // const buttonClickedEvent = {
              //   event_type: `v3_shape_carat_cell_click`,
              //   value: { shape, caratRange },
              // };
    // onCellClick(color, clarity, cellData);
    
  
    // Smooth scroll to the drilldown section
    setTimeout(() => {
      drilldownRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 100);
  };

      
  const handleSelectionChange = ({ colors, clarities }) => {
    // colors and clarities will be arrays of individual values
    // whether selected individually or as part of a group
    dispatch(setSelectedColors(colors))
    dispatch(setSelectedClarities(clarities));
    
  };
     
   
  // UseEffect for Shape changes
  useEffect(() => {
    
    setIsDataLoading(true);
  }, [selectedShape, selectedCaratRange, selectedCell]);

  // UseEffect for Carat Range changes
  
  const [hoveredCell, setHoveredCell] = useState(null);
  const handleCellHover = (column, row) => {
      setHoveredCell(column !== null && row !== null ? { column, row } : null);
    };
  
 

  useEffect(() => {
    if (!isColorClarityLoading){
      if (newData?.data) {
        const keys = Object.keys(newData.data);
        setColorKeys(keys);
        
        const mappedData = Object.values(newData.data).map(category =>
          Object.values(category)
        );
  
        const clarityfilterData = mappedData.map(category => 
          category.filter(item => typeof item === 'object')
        );
        setClarityDatas(clarityfilterData);
  
        Object.keys(newData.data).forEach(shapeKey => {
          // Extract carat ranges for this specific shape
          const clarityRanges = Object.keys(newData.data[shapeKey]).filter(key => key !== 'trans');
          // Add carat ranges to the array
          setAllClarityRanges(clarityRanges)
  
        });

       
      }
      
    }
  }, [newData?.data, selectedNeedsMetric, selectedLocation]);

  useEffect(() => {
    if (!isColorClarityLoading && newData) {
      setIsDataLoading(false);
    }
  }, [isColorClarityLoading, newData]);
  

  return (
    <div className="w-full flex-col justify-center items-start mx-auto">
        <div className="flex justify-center items-center w-full mx-auto px-2 gap-2">
          {isDataLoading ? (
                  <div className="flex justify-center w-[711px] items-center h-full">
                              <ColorRing
                                visible={true}
                                height="60"
                                width="60"
                                ariaLabel="blocks-loading"
                                colors={["#00319f", "#2e56b1", "#5c7bc2", "#8aa1d3", "#b2c1e2"]}
                              />
                    </div>
                ) : (
                  <MIDetailedColorClarity
                    idealTurn={1}
                    isCsr={isCsr}
                    isColorClarityLoading={isColorClarityLoading}
                    newData={newData}
                    colorKeys={colorKeys}
                    clarityDatas={clarityDatas}
                    allClarityRanges={allClarityRanges}
                    selectedMetric={selectedMetric}
                    handleCellClick={handleCellClick}
                    roundIfFloat={roundIfFloat}
                    roundToOneDecimal={roundToOneDecimal}
                    getBgColor={getBgColor}
                    getCellStyle={getCellStyle}
                    selectedCell={selectedCoClCell}
                    drilldownRef={drilldownRef}
                    filtered={queryParams.filters}
                    shape={shape}
                    caratRange={caratRange}
                    selectedNeedsMetric={selectedNeedsMetric}
                    selectedLocation={selectedLocation}
                    hoveredCell={hoveredCell}
                    handleCellHover={handleCellHover}
                  />
                  
                )}
         
                <MIHigherLevelIndividualMoment accountDetails={accountDetails} selectedNeedsMetric={selectedNeedsMetric} selectedLocation={selectedLocation} selectedShape={selectedShape} selectedCaratRange={selectedCaratRange} />
        </div>  
          <br></br>
          <br></br>
          <hr />
          <p ref={drilldownRef}></p>
          <br className="mt-4"></br>  
              {(selectedClarity && selectedColor) && (
                <MIFourDropGraph accountDetails={accountDetails} selectedNeedsMetric={selectedNeedsMetric} selectedLocation={selectedLocation} />
              )}
      
    </div>
  );
};

export default MIColorClarityGrid;





